import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ASSETS_API_URL } from '@app/app.constants';
import { I18nService } from '@app/i18n/i18n.service';

@Component({
  selector: 'app-i18n',
  templateUrl: './i18n.component.html',
  styleUrls: ['./i18n.component.scss'],
})
export class I18nComponent {
  @Input() menuClass = '';
  public picturesServer = ASSETS_API_URL;

  constructor(
    private i18nService: I18nService,
    private readonly router: Router,
    private route: ActivatedRoute
  ) {}

  get currentLanguage(): any {
    return this.i18nService.getLanguage();
  }

  get languages(): any[] {
    return this.i18nService.supportedLanguages;
  }

  setLanguage(language: any) {
    const currentPath = this.router.url.replace(
      /^\/(es|en)(?=\/|\?|$)/,
      '/' + language.minLag
    );
    this.redireccionExitosa(currentPath);
    this.i18nService.language = language.minLag;
  }

  redireccionExitosa(currentPath: string) {
    let params: any;
    if (currentPath.split('?').length > 1) {
      params = JSON.parse(
        '{"' +
          decodeURI(currentPath.split('?')[1])
            .replace(/"/g, '\\"')
            .replace(/&/g, '","')
            .replace(/=/g, '":"') +
          '"}'
      );
    }
    this.router.navigate([currentPath.split('?')[0]], { queryParams: params });
  }
}
